import React from "react";
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { getLabel } from "../../../data/labels";

export default function SystemBetsDetailTicketTuples(props) {
    const cs = getConfiguration().cs;
    const ticketData = props.ticketData;
    const clearBoth = {clear: "both"};
    let totWin = 0;

    return (
        <>
            <div>
                <div className="separator"></div>
                <div className="textcenter td-100 ticketType uppercase">{getLabel('printer.system_bet_details_ticket.tuples.combinations')}</div>
                <div className="separator"></div>
            </div>

            <table className="combinations">
                <tr>
                    <td className="textleft">{getLabel('printer.plain_ticket.footer.type')}</td>
                    <td className="textright">{getLabel('printer.plain_ticket.footer.combs')}</td>
                    <td className="textright">{getLabel('printer.plain_ticket.footer.bet_amount')}</td>
                    <td className="textright">{getLabel('printer.system_bet_details_ticket.tuples.tot_amount')}</td>
                </tr>
                {
                 ticketData?.tuples &&  ticketData.tuples.map(function(t){
                        const reactKey = 'tupla-' + t.id;
                        const price =  t.amount*t.combs;
                        return(
                            <tr key={reactKey} className="npla">
                                <td className="textleft">{t.id}{getLabel('betslip.pla')}</td>
                                <td className="textright">{t.combs}</td>
                                <td className="textright">{getPrintableAmount(t.amount, cs.m, cs.nd, cs.ct)}</td>
                                <td className="textright">{getCurrencyValue(price, cs.m, cs.nd, cs.ct)}</td>
                            </tr>
                        )
                    })
                }
            </table>

            <div className="separatorDashed"></div>
            <table className="combinations">
                <tr>
                    <td className="textleft">{getLabel('printer.plain_ticket.footer.combs')}</td>
                    <td className="textright">{getLabel('printer.system_bet_details_ticket.tuples.win')}</td>
                </tr>
                {ticketData?.combinations && Object.values(ticketData?.combinations).map((c,i)=> {
                    const reactKey = 'ticket-selection-' + c.c;
                    totWin=totWin+c.w;

                    return (
                        <>
                            <tr key={reactKey} className="npla">
                                <td className="textleft">{i+1}){c.c}</td>
                                <td className="textright">{getCurrencyValue(c.w, cs.m, cs.nd, cs.ct)}</td>
                            </tr>
                        </>
                        
                    )
                })}
            </table>
            
            <table className="combinations">
                <tr className="npla">
                    <td className="textleft">{getLabel('printer.plain_ticket.footer.total_potential_winnings')}</td>
                    <td className="textright">{getCurrencyValue(totWin, cs.m, cs.nd, cs.ct)}</td>
                </tr>
            </table>
            <div className="separatorDashed"></div>
        </>
    )
}